// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress[data-v-70b22ab4]{border-radius:1rem}", "",{"version":3,"sources":["webpack://src/components/shared/AppProgress.vue"],"names":[],"mappings":"AAAA,2BAA2B,kBAAkB","sourcesContent":[".progress[data-v-70b22ab4]{border-radius:1rem}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
